import unionBy from 'lodash/unionBy';
import filter from 'lodash/filter';

import * as actions from './ProspectActions';
import { ROUTE_CHANGED } from '../App/AppActions';

import { UPDATE_PROSPECT_CONTACT } from '../Contact/ContactActions';

const initialState = {
  list: [],
  detail: {},
  tab: 'open',
  search: {
    text: '',
    result: [],
  },
  info: {
    loading: false,
    start: -30,
    count: 30,
    hasMore: true,
    error: false,
  },
};

export default (state = initialState, action) => {
  if (action.type === ROUTE_CHANGED) {
    return { ...state, detail: {} };
  }
  const _prospects =
    action.start === 0 || action.tabChanged
      ? action.prospects
      : unionBy(state.list, action.prospects, '_id');
  const _list = state.list;
  switch (action.type) {
    case actions.CHANGE_TAB:
      return {
        ...state,
        list: [],
        search: {
          text: '',
          result: [],
        },
        tab: action.tab,
      };
    case actions.PROSPECTS_ERROR:
      return {
        ...state,
        info: { ...state.info, loading: false, error: action.error },
      };
    case actions.CLEAR_SEARCH:
      return {
        ...state,
        search: {
          text: '',
          result: [],
        },
      };
    case actions.RENDER_PROSPECTS:
      return {
        ...state,
        list: action.text ? _list : _prospects,
        search: {
          text: action.text,
          result: !action.text ? state.search.result : action.prospects,
        },
        info: {
          ...state.info,
          loading: false,
          hasMore: action.prospects.length === state.info.count,
        },
      };
    case actions.LOADING_PROSPECTS:
      return {
        ...state,
        info: {
          ...state.info,
          loading: true,
          start: action.start,
        },
      };
    case actions.DISPLAY_PROSPECT:
      return {
        ...state,
        detail: action.prospect,
      };
    case actions.UPDATE_PROSPECT:
      if (action.detail) {
        return {
          ...state,
          list: state.list.map(l => {
            if (l._id === action.prospect) {
              return { ...l, ...action.body };
            }
            return l;
          }),
          detail: {
            ...state.detail,
            ...action.body,
          },
        };
      }
      return state;
    case UPDATE_PROSPECT_CONTACT:
      if (action.detail) {
        const household = { ...state.detail.household };
        if (action.body.givenName || action.body.surname) {
          const givenName =
            action.body.givenName || state.detail.contact.givenName;
          const surname = action.body.surname || state.detail.contact.surname;
          household.name = `${givenName} ${surname} Household`;
        }
        return {
          ...state,
          detail: {
            ...state.detail,
            household,
            contact: {
              ...state.detail.contact,
              ...action.body,
            },
          },
        };
      }
      return state;
    case actions.ADD_PROSPECT_HOUSEHOLD:
      return {
        ...state,
        detail: {
          ...state.detail,
          household: action.household,
        },
      };
    case actions.DELETE_PROSPECT:
      return {
        ...state,
        list: [...filter(state.list, l => l._id !== action.prospect)],
        search: {
          ...state.search,
          result: [
            ...filter(state.search.result, r => r._id !== action.prospect),
          ],
        },
      };
    default:
      return state;
  }
};
